import { post } from "../utils/backend";
import { Order, OrderSearchParams, RefundRequest } from "../models/Order";
import { mock, getMockData } from "./mock/Mock"; 
import './mock/OrderMock';

// 获取订单列表
const getOrders = async (params: OrderSearchParams): Promise<Order[]> => {
    if (mock) {
        return getMockData("getOrders");
    }
    const resultOrErrorCode = await post<OrderSearchParams, Order[]>("/order/list", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

// 取消订单并退款
const cancelAndRefund = async (refundRequest: RefundRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<RefundRequest, boolean>("/order/cancelAndRefund", refundRequest);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

// 部分退款
const partialRefund = async (refundRequest: RefundRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<RefundRequest, boolean>("/order/partialRefund", refundRequest);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

// 修改订单佣金比例
const modifyOrderFeeRate = async (orderId: string, feeRate: number): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ orderId: string, feeRate: number }, boolean>("/order/modifyOrderFeeRate", { orderId, feeRate });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const OrderApi = {
    getOrders,
    cancelAndRefund,
    partialRefund,
    modifyOrderFeeRate
};